import { Helmet } from 'react-helmet-async';
import { Box, Grid, Link, Typography } from '@mui/material';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ChevronLeft } from '@mui/icons-material';

interface PageHeaderProps {
  title: string;
  heading?: string | null;
  backRef?: string | null;
  children?: React.ReactNode;
}

export default function PageHeader({ title, heading, backRef, children }: PageHeaderProps) {
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <>
      <Helmet title={title} />
      <Grid justifyContent="space-between" container spacing={3} mb={isSmUp ? 3 : 2}>
        <Grid item>
          {backRef && (
            <Box display="inline-block" paddingRight={3}>
              <Link aria-label="Breadcrumb" component={NavLink} to={backRef}>
                <ChevronLeft sx={{ verticalAlign: 'middle', fontSize: 32, position: 'relative', top: -5 }} />
                <Typography variant="h4" display="inline-block" position="relative" top={-2} left={-3}>
                  Back
                </Typography>
              </Link>
            </Box>
          )}
          <Typography pl={isSmUp ? 2 : 1} pr={0} variant="h3" display="inline-block">
            {heading || title}
          </Typography>
        </Grid>
        <Grid item pr={1}>
          {children}
        </Grid>
      </Grid>
    </>
  );
}
